<template>
    <div class="p-medical-records">
        <div class="card">
            <div class="card-header">
                <div class="font-weight-bold">{{ $locale.consultation_host }}記録一覧<span class="text-muted small">（最新15件まで）</span>
                </div>
            </div>

            <div class="card-body">
                <div v-if="medicalRecords !== null">
                    <b-table
                        :items="medicalRecords"
                        :fields="fields"
                        striped
                        hover
                        responsive>
                        <template v-slot:cell(consultation.start_time)="data">
                            <div>
                                <span>{{ helper.dateForHuman(data.item.consultation.start_time, timezone, {simpleYear: true}) }}</span>
                                <span
                                    class="small font-weight-bold"
                                    :class="helper.dayForHumanCSS( data.item.consultation.start_time ,timezone )">
                                    {{ helper.dayForHuman(data.item.consultation.start_time, timezone, {bracket: true}) }}
                                </span>
                            </div>
                            <div>{{ helper.timeForHuman(data.item.consultation, timezone) }}</div>
                        </template>
                        <template v-slot:cell(consultation.doctor.full_name_kana)="data">
                            <template v-if="data.item.doctor">
                                <a href="#" @click="showModalDoctorProfile(data.item.doctor_id, $event)">
                                    {{ data.item.doctor.full_name }}
                                </a>
                                <div class="small">{{ data.item.doctor.full_name_kana }}</div>
                            </template>
                            <template v-else-if="data.item.consultation.doctor_id === null">
                                <span class="text-muted">未定</span>
                            </template>
                        </template>
                        <template v-slot:cell(links)="data">
                            <b-button
                                size="sm"
                                variant="yokumiru-dark-green"
                                :href="createMedicalRecordUrl(data.item.consultation_id)">
                                記録
                            </b-button>
                        </template>
                    </b-table>
                </div>
                <div
                    v-else
                    class="d-flex justify-content-center align-items-center p-5">
                    <b-spinner variant="yokumiru-admin"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import YokumiruHelper from '../../YokumiruHelper'
import constants from '../../constants'

export default {
    props: {
        user: {
            type: Object,
            default: null,
        },
        doctor_id: {
            type: Number,
            default: null,
        },
        timezone: null,
    },

    data: function () {
        return {
            helper: YokumiruHelper,
            medicalRecords: null,
            fields: [
                {
                    key: 'consultation.start_time',
                    label: '予約日時',
                    sortable: false,
                },
                {
                    key: 'consultation.medical_course.name',
                    label: `${this.$locale.consultation_host}科`,
                    sortable: false,
                },
                {
                    key: 'consultation.doctor.full_name_kana',
                    label: '医師名',
                    sortable: false,
                },
                {
                    key: 'links',
                    label: '',
                    class: 'text-right',
                    sortable: false,
                },
            ],
        };
    },

    created: function () {
        this.fetchMedicalRecords();
    },

    methods: {
        /**
         * 医師詳細モーダル表示
         *
         * @param {number} doctorId
         * @param {object} e
         */
        showModalDoctorProfile: function (doctorId, e) {
            e.preventDefault()
            bus.$emit('open-modal-admin-doctor-profile', doctorId)
        },

        /**
         * 相談記録一覧取得
         */
        fetchMedicalRecords: function () {
            let query = `?user_id=${this.user.id}`
            if (this.doctor_id != null && this.doctor_id > 0) {
                query += `&doctor_id=${this.doctor_id}`
            }

            axios.get(`${constants.admin.medical_records.endpoint.base}${query}`)
                .then(({data}) => {
                    this.medicalRecords = data.data
                })
        },

        /**
         * 相談記録URL生成
         * @param {number} consultationId
         * @return {string}
         */
        createMedicalRecordUrl: function (consultationId) {
            return `/admin/consultations/${consultationId}`
        },
    },
}
</script>
